import { num2 } from './format.js';
const t = (term, hint) => ({
    term,
    hint: typeof hint === 'string' ? () => hint : hint,
});
export const GLOSSARY = {
    // По auto-ads (`payback-aggregate.ts`): roas3 = Σ(прогноз выручки − потери −
    // комиссии) / расход — комиссии УЖЕ вычтены; θ = THRESHOLD_WITH_FEES (1,08),
    // смысл которого в коде — «порог с учётом комиссий платёжки». Чтобы не
    // утверждать, что комиссии вычитаются дважды или ни разу, порог описан
    // нейтрально: «такой запас заложен в расчёт».
    roas: t('Вернётся на 1 $', (θ) => `Сколько вернётся за 120 дней на каждый потраченный доллар — уже за вычетом возвратов, споров и комиссий платёжки. Окупается, если не меньше ${num2(θ)} $ (порог).`),
    threshold: t('Порог', (θ) => `Порог окупаемости — ${num2(θ)} $ на каждый 1 $: такой запас заложен в расчёт.`),
    band: t('Полоса на шкале', 'Скорее всего результат будет в этих пределах: так выйдет в 8 случаях из 10.'),
    dot: t('Точка на шкале', 'Самый вероятный результат.'),
    prevRing: t('Кольцо на шкале', 'Тот же показатель за прошлый период — для сравнения.'),
    chance: t('Шанс', (θ) => `Вероятность, что окупимся, то есть вернётся не меньше ${num2(θ)} $ на каждый 1 $.`),
    verdict: t('Вывод', '«Скорее да» — шанс окупиться от 80 %, «Скорее нет» — до 20 %, между ними «Неясно». При покупках меньше 30 вывода нет, от 30 до 183 он предварительный.'),
    cpp: t('Цена покупки', 'Сколько стоила одна покупка (старт триала) по нашей платёжке, а не по данным Facebook.'),
    breakeven: t('В ноль до', 'Цена покупки, при которой реклама окупается ровно на пороге. Дороже — в минус.'),
    safe: t('Уверенно до', 'Цена покупки, при которой окупимся с шансом 80 %.'),
    gap: t('Не хватает / запас', (θ) => `Сколько долларов за 120 дней (после возвратов, споров и комиссий) не хватит до окупаемости (минус) или вернётся сверх неё (плюс). Окупаемость — ${num2(θ)} $ на каждый потраченный 1 $.`),
    best: t('В лучшем случае', 'Верхняя граница правдоподобного: даже так кампания не дотягивает до порога.'),
    spend: t('Расход', 'Сколько потрачено на рекламу за период.'),
    purchases: t('Покупки', 'Сколько было покупок (стартов триала) за период — по нашей платёжке, а не по данным Facebook.'),
    fact: t('Уже вернулось', 'Деньги, которые эти покупатели уже реально заплатили, без прогноза. Будет расти, пока идут продления.'),
    factRoas: t('Вернулось к сегодня', 'Сколько уже реально вернулось на каждый потраченный 1 $, без прогноза. Будет расти, пока идут продления.'),
    age: t('Возраст покупок', 'Сколько в среднем дней прошло с покупки. Чем моложе покупки, тем больше денег ещё впереди.'),
    coverage: t('Покрытие прогнозом', 'Доля покупок, для которых модель уже сделала прогноз. Расход остальных распределён по ним.'),
    h60: t('60 дн', 'Тот же прогноз «на 1 $», но за 60 дней, а не за 120.'),
    h90: t('90 дн', 'Тот же прогноз «на 1 $», но за 90 дней, а не за 120.'),
    h120: t('120 дн', 'Прогноз «на 1 $» за 120 дней — этот срок раздел использует для вывода.'),
    allAccounts: t('Все кабинеты', 'Сколько вернётся на 1 $ по всем выбранным кабинетам вместе. Серым — сколько было покупок.'),
    oneAccount: t('Кабинет', 'Сколько вернётся на 1 $ в этом кабинете. Серым — сколько было покупок. Бледно — покупок меньше 30, оценка ненадёжна.'),
    fact60: t('Факт 60', 'Сколько реально вернулось за 60 дней у покупок, которым уже есть 60 дней.'),
    fact90: t('Факт 90', 'Сколько реально вернулось за 90 дней у покупок, которым уже есть 90 дней.'),
    fact120: t('Факт 120', 'Сколько реально вернулось за 120 дней у покупок, которым уже есть 120 дней.'),
    moment: t('Момент прогноза', 'Когда сделан прогноз: сразу при покупке, через сутки или на 14-й день. Чем позже, тем точнее: на 14-й день уже известно первое продление.'),
    share: t('Доля покупок', 'Какая часть покупок периода приходится на это значение.'),
    spread: t('Разброс', 'Насколько отличается окупаемость лучшей и худшей группы. Чем больше разброс, тем сильнее признак разделяет покупателей.'),
    preliminary: t('Предварительно', 'Расход за этот день ещё не окончательный: Meta его пересчитает.'),
    freshness: t('Расход учтён по', 'Каждый день закрывается на следующее утро, когда Meta присылает итоговые траты. Через 3 и 7 дней мы сверяем цифры ещё раз, потому что Meta иногда поправляет их задним числом. Сегодняшний и вчерашний (до утра) расход — предварительный.'),
    late: t('Опоздания / неполные', 'Доля прогнозов, сделанных позже срока или по неполным данным о покупке.'),
};
/** Подсказка термина при пороге `theta`. */
export function hintOf(key, theta) {
    return GLOSSARY[key].hint(theta);
}
/**
 * Колонки таблиц → термин словаря. Для подключения `SortableHeader hint`:
 * `hint={columnHint(key, theta)}`. Колонки-названия (кампания, значение,
 * кабинет, период) подсказки не получают — там нечего объяснять.
 */
export const COLUMN_HINTS = {
    spend: 'spend',
    purchases: 'purchases',
    roas: 'roas',
    p: 'chance',
    chance: 'chance',
    verdict: 'verdict',
    cpp: 'cpp',
    breakeven: 'breakeven',
    safe: 'safe',
    gap: 'gap',
    hi: 'best',
    fact: 'fact',
    age: 'age',
    coverage: 'coverage',
    h60: 'h60',
    h90: 'h90',
    h120: 'h120',
    all: 'allAccounts',
    fact60: 'fact60',
    fact90: 'fact90',
    fact120: 'fact120',
    moment: 'moment',
    share: 'share',
};
/**
 * Где одинаковый ключ колонки значит разное: «Вернулось» в «Кампаниях» и
 * «Одном признаке» — на 1 $, в «Динамике» — в долларах.
 */
export const FACT_PER_DOLLAR = { fact: 'factRoas' };
/**
 * Подсказка к колонке по её ключу; нет термина — `undefined`. `aliases` —
 * термины этой таблицы, отличные от общих (`FACT_PER_DOLLAR`).
 */
export function columnHint(key, theta, aliases) {
    const g = aliases?.[key] ?? COLUMN_HINTS[key];
    return g ? hintOf(g, theta) : undefined;
}
//# sourceMappingURL=glossary.js.map